import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ breakpoints }: Theme) =>
  createStyles({
    root: () => ({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      backgroundColor: palette.orange,
      background: `linear-gradient(45deg, ${palette.orange} 20%, ${palette.deepBlue} 80%)`,
    }),
    header: {
      position: 'absolute',
      top: 0,
      left: '50%',
      display: 'flex',
      width: '50%',
      height: 45,
      background: palette.white,
      zIndex: 3,
    },
    logo: {
      maxWidth: '100%',
      [breakpoints.down('lg')]: {
        maxWidth: '75%',
      },
    },
    col: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',

      [breakpoints.up('md')]: {
        position: 'relative',
        width: '33%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
      },
    },
    colContent: {
      maxWidth: 370,
      textAlign: 'center',

      '& img': {
        maxWidth: 250,
      },

      '& p': {
        color: palette.darkGray,
        fontWeight: 400,
        fontSize: 22,
      },
    },
    imageBack: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      pointerEvents: 'none',
    },
    wrapContent: {
      position: 'relative',
      zIndex: 2,

      [breakpoints.up('md')]: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: palette.white,
        width: '67%',
        height: '100%',
      },

      '& .grecaptcha-badge': {
        marginBottom: 90,
        [breakpoints.down(960)]: {
          marginBottom: 35,
        },
      },
    },
    mobileTop: { top: '25%' },
    content: {
      width: 'calc(100% - 32px)',
      maxWidth: 400,
      margin: '0 auto',
      textAlign: 'center',

      '& input': {
        background: 'transparent',
      },

      [breakpoints.down('sm')]: {
        '& h3, h6, p, a': {
          color: palette.white,
          textShadow: '0 1px 3px rgba(0, 0, 0, .3)',
          [breakpoints.down('lg')]: {
            color: palette.white,
            textShadow: '0',
          },
        },

        '& .MuiFormLabel-root:not(.Mui-error)': {
          color: palette.white,
        },

        '& .MuiIconButton-root': {
          color: palette.white,
        },
      },

      [breakpoints.up('md')]: {
        textAlign: 'center',

        '& a': {
          color: palette.secondary.main,
          textShadow: 'none',
          alignItems: 'inherit',
        },
      },
    },
    copyrightWrapper: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      width: '100%',
      height: 45,
      paddingLeft: 16,
      background: palette.lightGray,
    },
    link: {
      fontSize: 12,
      textDecoration: 'none',
      marginRight: 16,

      '& p': {
        margin: 0,
        fontSize: 12,
      },

      '&:hover': {
        textDecoration: 'underline',
      },
    },
    copyLogo: {
      display: 'flex',
      justifyContent: 'flex-end',
      flex: 1,

      '& img': {
        width: 110,
      },
    },
    text: { color: palette.darkGray },
    logoSubtitle: { paddingTop: 170, position: 'absolute' },
  });
